import React, { useContext, useState } from "react";
import { useMutation } from "@apollo/client";
//Import from project
import { AuthContext } from "../../../../../Context/AuthContext";
import {
  CREATE_EXAM_TYPE,
  UPDATE_EXAM_TYPE,
} from "../../../../../Schema/ExamType";

const useExamType = ({ handleClose, resetForm, setRefetch }) => {
  // Change Language
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [createExamType] = useMutation(CREATE_EXAM_TYPE, {
    onCompleted: ({ createExamType }) => {
      setLoading(false);

      if (createExamType?.isSuccess === true) {
        setAlert(true, "success", createExamType?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createExamType?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const [updateExamType] = useMutation(UPDATE_EXAM_TYPE, {
    onCompleted: ({ updateExamType }) => {
      setLoading(false);
      if (updateExamType?.isSuccess === true) {
        setAlert(true, "success", updateExamType?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", updateExamType?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  return { updateExamType, createExamType, loading, setLoading };
};

export default useExamType;
